(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const anchorLinks = document.querySelectorAll('.anchor-jump-link');
    
    anchorLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        const targetClass = this.getAttribute('data-anchor-class');
        if (!targetClass) return;
        
        const targetElement = document.querySelector('.' + targetClass);
        
        if (targetElement) {
          targetElement.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
          
          // Optional: Add a highlight effect
          targetElement.classList.add('anchor-highlight');
          setTimeout(() => {
            targetElement.classList.remove('anchor-highlight');
          }, 2000);
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
